export default __webpack_public_path__ + "static/placeholder-682f641b511f28c3fafd788ea026ecc5.png";